import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',

})
export class RegistroComponent {

  reclamoForm!: FormGroup;
  reCAPTCHAToken: string = "";
  ModalActivate= false;
  respMensaje='';
  respEstado='';

  constructor( ) {}

  ngOnInit() {
  }

}
